import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Stats from './components/Stats';
import About from './components/About';
import Services from './components/Services';
import Sales from './components/Sales';
import AMC from './components/AMC';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Navbar />
      <Hero />
      <Stats />
      <About />
      <Services />
      <Sales />
      <AMC />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
